<template>
  <b-select @input="onInput" v-model="selectedAdses" expanded :placeholder="$tc('ads.ads')+' '+$tc('select')">
    <option
      v-for="(ads, index) in adses.data"
      :loading="adses.loading"
      :key="index"
      :value="ads.id"
    >{{ ads.name }}</option>
  </b-select>
</template>

<script>
export default {
  props: {
    type: String,
    defaultAdses: Object
  },
  data() {
    return {
      selectedAdses: this.defaultAds,
      adses: new window.RemoteCollection("/admin/api/adses/index")
    };
  },
  created() {
    this.adses.load();
  },
  watch: {
    selectedAdses() {
      this.$emit("input", this.selectedAdses);
    }
  },
  methods: {
    onInput(id) {
      this.$emit("input", id);

      this.$emit(
        "change",
        this.adses.data.find(c => c.id === id)
      );
    }
  }
};
</script>
